import React, { useCallback, useRef, useState } from 'react';
import { Play } from 'lucide-react';

const VIDEO_SRC = `${process.env.PUBLIC_URL || ''}/self-hosted-demo-v1.mp4`;
const POSTER_SRC = `${process.env.PUBLIC_URL || ''}/self-hosted-demo-poster.jpg`;

export default function DemoVideo({ className = '' }) {
  const videoRef = useRef(null);
  const [showOverlay, setShowOverlay] = useState(true);

  const handlePlay = useCallback(async () => {
    const video = videoRef.current;
    if (!video) return;
    try {
      await video.play();
      setShowOverlay(false);
    } catch {
      // Browser blocked autoplay after gesture - overlay stays visible.
    }
  }, []);

  const handlePlayEvent = useCallback(() => {
    setShowOverlay(false);
  }, []);

  const handlePause = useCallback(() => {
    setShowOverlay(true);
  }, []);

  const handleEnded = useCallback(() => {
    setShowOverlay(true);
  }, []);

  return (
    <div className={`relative overflow-hidden rounded-card bg-terminal shadow-e2 ${className}`.trim()}>
      <div className="aspect-video">
        <video
          ref={videoRef}
          className="h-full w-full object-cover"
          poster={POSTER_SRC}
          preload="none"
          controls
          playsInline
          onPlay={handlePlayEvent}
          onPause={handlePause}
          onEnded={handleEnded}
        >
          <source src={VIDEO_SRC} type="video/mp4" />
        </video>
      </div>

      {showOverlay && (
        <button
          type="button"
          onClick={handlePlay}
          aria-label="Play self-hosted Hushify demo video"
          className="absolute inset-0 flex items-center justify-center bg-terminal/40 transition-colors hover:bg-terminal/55 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
        >
          <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-accent text-accent-fg shadow-e3 transition-transform hover:scale-105">
            <Play className="h-6 w-6 ml-0.5" fill="currentColor" aria-hidden="true" />
          </span>
        </button>
      )}
    </div>
  );
}
